import React, { FC } from 'react';

import { HomeGatewayUpgrade as HomeUpgradeModel } from 'app/api/@generated/backend';

import { ProductInformation } from 'app/pages/order/summary/product-information/product-information';
import { i18n } from 'app/i18n';
import { homeGatewayImageProps } from 'app/resources/images';
import { CurrencyUtils } from 'app/utils/currency-utils';
import { OrderStaticData } from 'app/static-data/order-static-data';

interface Props {
    homeGatewayUpgrade: HomeUpgradeModel;
}

export const HomeGatewayUpgrade: FC<Props> = (props) => {
    const { homeGatewayUpgrade } = props;

    return (
        <ProductInformation
            productName={homeGatewayUpgrade.displayName}
            image={homeGatewayImageProps}
            amount={OrderStaticData.HOME_GATEWAY_UPGRADE_AMOUNT}
            price={CurrencyUtils.formatPriceWithSuffix(homeGatewayUpgrade.onceOnlyCharge.price)}
            amountText={i18n.page.summary.productInformation.quantity}
        />
    );
};
